import { render, staticRenderFns } from "./SupportAppButton.vue?vue&type=template&id=7a4a8b4c&"
import script from "./SupportAppButton.vue?vue&type=script&lang=js&"
export * from "./SupportAppButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports